import * as React from 'react';

import * as Images from 'pos/Images';

import * as API from 'core/api';
import { OfferInListDTO, Res } from 'core/api';
import { Modal } from 'core/ui-next/modal';
import { CustomList, SvgIcon } from 'core/ui-next';
import { BackActionButton, Content, Footer, Header, PhoneOnly, PosScreen } from 'pos/ui';
import { Box, Text, VStack } from '@chakra-ui/react';

type Props = {
	offers: OfferInListDTO[]
} & Modal.Actions<OfferInListDTO>;

function SelectTicketOffer(props: Props) {

	const { offers, cancel, close } = props;

	//State
	const [offersList] = React.useState<API.OfferInListDTO[]>(offers);

	const onCancel = React.useCallback(async () => cancel(), [cancel]);

	const onSelectOffer = (offer: OfferInListDTO) => close(offer);

	return <PosScreen screenId={'SELECT_TICKET_OFFER'} size={'small'}>
		<Header title={Res.Web.SELECT_TICKET_OFFER()} image={Images.AgoraLogo} onClose={onCancel} />
		<Content>
			<VStack paddingX={'6'} paddingY={'9'} width={'full'} height={'full'} gap={'6'} alignItems={'stretch'}>
				<VStack gap={'4'} justifyItems={'center'} w='full'>
					<SvgIcon src={Images.Offer} w={'12'} h={'12'} />
					<Text fontSize={'md'} fontWeight={'semibold'}>
						{Res.Web.OFFERS_CLM()}
					</Text>
				</VStack>
				{/* La lista crece con su contenido y es este contenedor el que hace el scroll vertical */}
				<Box width={'full'} flex={'1'} minH={'0'} overflowY={'auto'}>
					<CustomList
						items={offersList}
						itemKey={offer => offer.Id}
						itemText={offer => offer.Name}
						onSelectItem={onSelectOffer}
					/>
				</Box>
			</VStack>
		</Content>
		<Footer>
			<PhoneOnly>
				<BackActionButton action={onCancel} />
			</PhoneOnly>
		</Footer>
	</PosScreen>;
}


export async function selectTicketOffer(offers: API.OfferInListDTO[]): Promise<Result<OfferInListDTO>> {
	return await Modal.show(SelectTicketOffer, { offers });
}